export const ADMIN_PERMISSION_ACTIONS = Object.freeze([
  { key: 'view', label: '조회' }, { key: 'export', label: '다운로드' }, { key: 'edit', label: '등록·수정' }, { key: 'approve', label: '승인·처리' },
])
export const ADMIN_PERMISSION_MENUS = Object.freeze([
  { key: 'dashboard', label: '대시보드', paths: ['/dashboard'] },
  { key: 'members', label: '회원 관리', paths: ['/members'] },
  { key: 'directors', label: '디렉터 관리', paths: ['/director-reviews', '/directors'] },
  { key: 'quotes', label: '견적·주문·진행', paths: ['/quote-requests', '/quotes', '/orders', '/projects'] },
  { key: 'finance', label: '결제·환불·분쟁·정산', paths: ['/payments', '/refunds', '/settlements'] },
  { key: 'ai', label: 'AI 운영', paths: ['/ai'] },
  { key: 'adminContent', label: '메인·관리자 콘텐츠', paths: ['/content/home', '/content/branding', '/content/notices', '/content/stories', '/content/events', '/content/banners', '/content/info-pages'] },
  { key: 'ugc', label: '회원·디렉터 콘텐츠', paths: ['/content/portfolios', '/content/reviews', '/content/moderation'] },
  { key: 'support', label: '고객지원', paths: ['/support'] },
  { key: 'settings', label: '서비스·운영 설정', paths: ['/settings'] },
  { key: 'system', label: '관리자·감사 로그', paths: ['/system'] },
])

export const ADMIN_SENSITIVE_CAPABILITIES = Object.freeze([
  { key: 'refund.process', label: '환불 실행·승인·반려' },
  { key: 'settlement.export_sensitive', label: '정산 은행이체 민감파일 생성·다운로드' },
  { key: 'settlement.account_verify', label: '정산계좌·통장사본 검증' },
])

const ALL = { view: true, export: true, edit: true, approve: true }
const READ = { view: true, export: false, edit: false, approve: false }
const READ_EXPORT = { view: true, export: true, edit: false, approve: false }
const EDIT = { view: true, export: true, edit: true, approve: false }
const NONE = { view: false, export: false, edit: false, approve: false }

const SERVER_RESOURCE_BY_MENU = Object.freeze({
  members: 'members',
  directors: 'directors',
  quotes: 'quotes',
  finance: 'finance',
  ai: 'ai',
  adminContent: 'content',
  ugc: 'content',
  support: 'support',
  settings: 'catalog',
  system: 'system',
})

export function permissionPreset(role) {
  const base = Object.fromEntries(ADMIN_PERMISSION_MENUS.map((menu) => [menu.key, { ...NONE }]))
  if (role === 'SUPER_ADMIN') return Object.fromEntries(ADMIN_PERMISSION_MENUS.map((menu) => [menu.key, { ...ALL }]))
  if (role === 'OPERATIONS') return { ...base, dashboard: { ...READ }, members: { ...READ_EXPORT }, directors: { ...EDIT }, quotes: { ...ALL }, finance: { ...READ_EXPORT }, support: { ...EDIT }, ugc: { ...EDIT } }
  if (role === 'CONTENT_MANAGER') return { ...base, dashboard: { ...READ }, adminContent: { ...EDIT }, ugc: { ...EDIT }, settings: { ...READ } }
  if (role === 'SUPPORT') return { ...base, dashboard: { ...READ }, members: { ...READ }, directors: { ...READ }, quotes: { ...READ }, support: { ...EDIT }, finance: { ...READ }, ugc: { ...READ } }
  if (role === 'FINANCE') return { ...base, dashboard: { ...READ }, members: { ...READ }, quotes: { ...READ_EXPORT }, finance: { ...ALL } }
  return base
}

export function sensitiveCapabilityPreset(role) {
  if (role === 'SUPER_ADMIN') return new Set(ADMIN_SENSITIVE_CAPABILITIES.map((item) => item.key))
  if (role === 'FINANCE') return new Set(['refund.process', 'settlement.export_sensitive', 'settlement.account_verify'])
  if (role === 'OPERATIONS') return new Set(['refund.process'])
  return new Set()
}

export function hasSensitiveCapability(role, capability) {
  return sensitiveCapabilityPreset(role).has(capability)
}

function serverPermission(row) {
  return {
    view: Boolean(row?.view),
    export: Boolean(row?.export),
    edit: Boolean(row?.edit),
    approve: Boolean(row?.process),
  }
}

export function normalizePermissions(role, permissions) {
  const preset = permissionPreset(role)
  if (role === 'SUPER_ADMIN') return preset

  if (Array.isArray(permissions)) {
    const byResource = new Map(permissions.map((row) => [row.resource, row]))
    const normalized = {}
    ADMIN_PERMISSION_MENUS.forEach((menu) => {
      const resource = SERVER_RESOURCE_BY_MENU[menu.key]
      if (!resource) {
        normalized[menu.key] = { ...preset[menu.key] }
        return
      }
      normalized[menu.key] = byResource.has(resource) ? serverPermission(byResource.get(resource)) : { ...NONE }
    })
    return normalized
  }

  const normalized = {}
  ADMIN_PERMISSION_MENUS.forEach((menu) => { normalized[menu.key] = { ...preset[menu.key], ...(permissions?.[menu.key] || {}) } })
  return normalized
}
export function permissionMenuForRoute(route) {
  const pathname = String(route || '/').split('?')[0]
  return ADMIN_PERMISSION_MENUS.find((menu) => menu.paths.some((path) => pathname === path || pathname.startsWith(`${path}/`))) || null
}
export function canPermission(permissions, route, action = 'view') {
  const menu = permissionMenuForRoute(route)
  if (!menu) return true
  return permissions?.[menu.key]?.[action] !== false
}
